export default {
  normal: "normal",
  new_order: "new_order",
  new_order_accepted: "new_order_accepted",
  second_submission: "second_submission"
};
